<template>
  <div class="watermark-wrapper">
    <div class="content">
      <div class="content-left">
        <!--是否启用水印-->
        <div class="content-left-item">
          <span class="must">*</span>
          <el-checkbox @change="isAdd" v-model="watermarkData.isOpen">是否启用水印</el-checkbox>
        </div>
        <!--选择图片文字水印-->
        <div class="content-left-item">
          <span class="must">*</span>
          <el-radio v-model="watermarkData.type" label="01" :disabled="!watermarkData.isOpen" @change="changeWatermark">图片水印</el-radio>
          <el-radio v-model="watermarkData.type" label="02" :disabled="!watermarkData.isOpen" @change="changeWatermark">文字水印</el-radio>
        </div>
        <!--图片水印-->
        <div v-if="watermarkData.type==='01'">
          <!--上传图片-->
          <div class="upload" style="margin-bottom: 6px;">
            <span class="must">*</span>
            <span class="text">选择图片：</span>
            <el-upload
                :disabled="!watermarkData.isOpen"
                class="avatar-uploader"
                :headers="accessToken"
                :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                :show-file-list="false"
                accept=".png, .jpg, .jpeg"
                :on-success="handleAvatarSuccess">
              <img v-if="watermarkData.picture" :src="'http://'+watermarkData.picture" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="color: red;margin-left: 78px;" class="content-left-item">建议尺寸：120*70像素</div>
          <!--大小。百分比 percentage-->
          <div class="content-left-item input-num" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <div style="font-size: 14px;text-align: right">百分比大小：</div>
            <el-input-number @input="changeWatermark" :disabled="!watermarkData.isOpen" v-model="watermarkData.percentage" placeholder="1～100" clearable :min="1" :max="100"></el-input-number>
            <!--                      <el-input type="number" :disabled="!watermarkData.isOpen" v-model="watermarkData.percentage" placeholder="请输入1～100" clearable></el-input>-->
          </div>
          <div class="content-left-item" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <span>图片角度：</span>
            <el-input type="number" @input="changeWatermark" :disabled="!watermarkData.isOpen" v-model="watermarkData.displayAngle" placeholder="请输入图片角度" clearable></el-input>
          </div>
        </div>
        <!--文字水印-->
        <div v-if="watermarkData.type==='02'">
          <div class="content-left-item" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <div style="font-size: 14px">文字内容：</div>
            <el-input
                style="width: 230px"
                @input="changeWatermark"
                :disabled="!watermarkData.isOpen"
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="watermarkData.content">
            </el-input>
          </div>
          <div class="content-left-item" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <span>文字类型：</span>
            <el-select v-model="watermarkData.fontType" @change="changeWatermark" placeholder="请选择文字类型" :disabled="!watermarkData.isOpen">
              <el-option
                  v-for="item in fontTypeList"
                  :key="item.value"
                  :label="item.valueDec"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="content-left-item" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <span>字体大小：</span>
            <el-input type="number" @input="changeWatermark" :disabled="!watermarkData.isOpen" v-model="watermarkData.fontSize" placeholder="请输入字体大小" clearable></el-input>
          </div>
          <div class="content-left-item" style="display: flex;justify-content: flex-start;align-items: center">
            <span class="must">*</span>
            <span>字体角度：</span>
            <el-input type="number" @input="changeWatermark" :disabled="!watermarkData.isOpen" v-model="watermarkData.displayAngle" placeholder="请输入字体角度" clearable></el-input>
          </div>
          <div class="content-left-item" style="margin-left:70px;">
            <span class="must">*</span>
            <span >颜色：</span>
            <el-color-picker
                @change="changeWatermark"
                :disabled="!watermarkData.isOpen"
                style="vertical-align: middle"
                v-model="watermarkData.fontColor"
                show-alpha
                :predefine="predefineColors">
            </el-color-picker>
          </div>
        </div>
        <!--透明度-->
        <div  class="content-left-item input-num">
          <span class="must">*</span>
          <span class="text">透明程度：</span>
          <el-input-number :disabled="!watermarkData.isOpen" v-model="watermarkData.transparency" placeholder="0～1" clearable :precision="1" :step="0.1" :min="0" :max="1" @input="changeWatermark"></el-input-number>
          <!--                  <el-input :disabled="!watermarkData.isOpen" v-model="watermarkData.transparency" @input="changeWatermark" placeholder="请输入内容" clearable></el-input>-->
        </div>
        <!--是否重复平铺-->
        <div class="content-left-item">
          <span class="must">*</span>
          <el-checkbox :disabled="!watermarkData.isOpen" v-model="watermarkData.isRepeat" @change="changeWatermark">是否重复平铺</el-checkbox>
        </div>
        <!--水平间距-->
        <div v-if="watermarkData.isRepeat"  class="content-left-item">
          <span class="must">*</span>
          <span class="text">水平间距：</span>
          <el-input type="number" :disabled="!watermarkData.isOpen" v-model="watermarkData.spacing" @input="changeWatermark" placeholder="请输入内容" clearable></el-input>
        </div>
        <!--垂直间距-->
        <div v-if="watermarkData.isRepeat"  class="content-left-item">
          <span class="must">*</span>
          <span class="text">垂直间距：</span>
          <el-input type="number" :disabled="!watermarkData.isOpen" v-model="watermarkData.verticalSpacing" @input="changeWatermark" placeholder="请输入内容" clearable></el-input>
        </div>
        <div v-if="!watermarkData.isRepeat">
          <!--水印位置-->
          <div  class="content-left-item">
            <span class="must">*</span>
            <span class="text">水印位置：</span>
            <el-select v-model="watermarkData.position" @change="changeWatermark" placeholder="请选择" :disabled="!watermarkData.isOpen">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.valueDec"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!--水平边距-->
          <div  class="content-left-item">
            <span class="must">*</span>
            <span class="text">水平边距：</span>
            <el-input type="number" :disabled="!watermarkData.isOpen" v-model="watermarkData.horizontal" @input="changeWatermark" placeholder="请输入内容" clearable></el-input>
          </div>
          <!--垂直边距-->
          <div  class="content-left-item">
            <span class="must">*</span>
            <span class="text">垂直边距：</span>
            <el-input type="number" :disabled="!watermarkData.isOpen" v-model="watermarkData.vertical" @input="changeWatermark" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <!--水印权限-->
        <div  class="content-left-item">
          <span class="must">*</span>
          <span class="text">水印权限：</span>
          <el-select multiple v-model="watermarkData.jurisdiction" placeholder="请选择" :disabled="!watermarkData.isOpen">
            <el-option
                v-for="item in jurisdictionList"
                :key="item.value"
                :label="item.valueDec"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content-right">
        <div class="text">预览：</div>
        <div id="picture">
          <el-image id="img" :src="newimgObj" :preview-src-list="[newimgObj]"></el-image>
          <!--                    <img id="img" :src="imgObj" alt="">-->
          <!--                    <canvas id="myCanvas" v-if="watermarkData.isOpen">您的浏览器不支持Canvas</canvas>-->
        </div>
      </div>
    </div>
    <div class="save1">
      <button @click="addWatermark" v-points>保存</button>
    </div>
  </div>
</template>

<script>
import {queryWatermark,addWatermark,updateWatermark} from '@/api/systemSetup'
export default {
  name: "watermarkSet",
  data(){
    let token = sessionStorage.getItem("accessToken");
    return {
      accessToken: {
        accessToken: token
      },
      //水印位置数据
      options:[
        {valueDec:'上左',value:'01'},
        {valueDec:'中左',value:'02'},
        {valueDec:'下左',value:'03'},
        {valueDec:'上中',value:'04'},
        {valueDec:'中间',value:'05'},
        {valueDec:'下中',value:'06'},
        {valueDec:'上右',value:'07'},
        {valueDec:'中右',value:'08'},
        {valueDec:'下右',value:'09'}
      ],
      //文字类型
      fontTypeList:[
        {valueDec:'宋体',value:'SimSun'},
        {valueDec:'黑体',value:'SimHei'},
        {valueDec:'微软雅黑',value:'microsoft yahei'},
        {valueDec:'微软正黑体',value:'Microsoft JhengHei'},
        {valueDec:'楷体',value:'KaiTi'},
        {valueDec:'新宋体',value:'NSimSun'},
        {valueDec:'仿宋',value:'FangSong'},
      ],
      //水印权限
      jurisdictionList:[
        {valueDec:'为所有图片添加水印',value:'01'},
        {valueDec:'为房源图片添加水印',value:'02'},
        {valueDec:'为带看图片添加水印',value:'03'},
        {valueDec:'为权证图片添加水印',value:'04'},
        {valueDec:'为楼盘字典图片添加水印',value:'05'},
      ],
      //水印
      watermarkData:{},
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      //预览图
      imgObj:require('../../assets/waterbg.jpg'),
      newimgObj:'',
    }
  },
  methods: {
    //
    isAdd(val){
      this.changeWatermark();
    },
    getIsRepeat(val){
      if (val){
        this.watermarkData.position = '';
        this.watermarkData.horizontal = 0;
        this.watermarkData.vertical = 0;
      }else {
        this.watermarkData.spacing=0
      }
    },
    //图片水印上传
    handleAvatarSuccess(res, file) {
      this.watermarkData.picture = res.uri;
      this.changeWatermark();
    },
    //查询水印
    queryWatermark(){
      this.$post(queryWatermark).then(res => {
        if (res.success === true) {
          this.watermarkData = res.data;
          this.watermarkData.isOpen = (this.watermarkData.isOpen=='1'||this.watermarkData.isOpen=='01')?true:false;
          this.watermarkData.isRepeat = (this.watermarkData.isRepeat=='1'||this.watermarkData.isRepeat=='01')?true:false;
          // if (!this.watermarkData.position){
          //     this.watermarkData.position='中间'
          // }
          if(!this.watermarkData.fontType){
            this.watermarkData.fontType = 'microsoft yahei'
          }
          if (!this.watermarkData.type){
            this.watermarkData.type='01'
          }
          if (!this.watermarkData.jurisdiction){
            this.watermarkData.jurisdiction=['01']
          }else {
            this.watermarkData.jurisdiction = this.watermarkData.jurisdiction.split(',')
          }
          sessionStorage.setItem('watermark',JSON.stringify(this.watermarkData));
          this.changeWatermark();
        }
      });
    },
    //添加水印
    addWatermark(){
      let params = {...this.watermarkData}
      params.isOpen = params.isOpen?'01':'02'
      params.isRepeat = params.isRepeat?'01':'02';

      if (params.type=='01'){
        params.content = '';
        params.fontSize = '';
        params.fontColor = '';
        params.fontType = '';
        if ( !params.picture){
          this.$message.error('图片不能为空！')
          return
        }
        if ( !params.percentage){
          this.$message.error('图片大小为空！')
          return
        }
      }else {
        params.picture='';
        params.percentage='';
        if ( !params.content){
          this.$message.error('文字内容不能为空！')
          return
        }
        if ( !params.fontType){
          this.$message.error('文字类型不能为空！')
          return
        }
        if ( !params.fontSize){
          if (params.fontSize==0){
            this.$message.error('字体大小不能为0！')
          }else {
            this.$message.error('字体大小为空！')
          }
          return
        }
        if ( !params.displayAngle&&params.displayAngle!=0){
          this.$message.error('字体角度不能为空！')
          return
        }
        if ( !params.fontColor){
          this.$message.error('文字颜色不能为空！')
          return
        }
      }
      if ( !params.transparency){
        this.$message.error('透明度不能为空！')
        return
      }
      if (!params.isRepeat){
        params.position = '';
        params.horizontal = '';
        params.vertical = '';
        if ( !params.spacing&&params.spacing!=0){
          this.$message.error('水平间距不能为空！')
          return
        }
      }else {
        this.watermarkData.spacing=''
        if ( !params.position){
          this.$message.error('水印位置不能为空！')
          return
        }
        if ( !params.horizontal&&params.horizontal!=0){
          this.$message.error('水平边距不能为空！')
          return
        }
        if ( !params.vertical&&params.vertical!=0){
          this.$message.error('垂直边距不能为空！')
          return
        }
      }
      if (params.jurisdiction.length==0){
        this.$message.error('水印权限不能为空！')
        return
      }
      params.jurisdiction = this.watermarkData.jurisdiction.join(',')
      let url = ''
      if (params.id){
        url=updateWatermark
      }else {
        url=addWatermark
      }
      this.$post(url,params).then(res => {
        if (res.success === true) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.queryWatermark();
        }
      });
    },
    //绘制水印
    async changeWatermark() {
      // if (this.watermarkData.id){
      //
      // }
      this.newimgObj = await this.$draw(this.imgObj,this.watermarkData)
    },
  },
  mounted() {
    this.queryWatermark();
  }
}
</script>
<style lang="less">
.watermark-wrapper{
  .el-input{
    width: 230px;
  }
  .el-input__inner{
    width: 230px;
    //height: 30px;
    //line-height: 30px;
  }
}
</style>

<style scoped lang="less">
/deep/ .input-num .el-input{
  width: 100%;
}
/deep/ .input-num .el-input__inner{
  width: 100%;
}
.watermark-wrapper{
  background: #ffffff;
  padding: 30px;
  height: 82vh;
  .content{
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    &-left{
      margin-right: 70px;
      width: 330px;
      &-item{
        margin-bottom: 20px;
      }
      .upload{
        display: flex;
        align-items: center;
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 4px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #5e75e6;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 120px;
          height: 70px;
          line-height: 70px;
          text-align: center;
        }
        .avatar {
          width: 120px;
          height: 70px;
          display: block;
        }
      }
    }
    &-right{
      .text{
        font-size: 14px;
        margin-bottom: 10px;
      }
      #picture{
        width: 380px;
        height: 200px;
        position: relative;
        #myCanvas{
          position: absolute;
          /*display: none;*/
          left: 0;
          right: 0;
          z-index: 10000;
        }
        #img{
          width: 380px;
          height: 200px;
        }
      }

    }
  }
  .save1{
    width: 750px;
    text-align: center;
    margin-top: 30px;
    button{
      width: 160px;
      height: 50px;
      background: #5E75E6;
      border: none;
      outline: none;
      border-radius: 4px;
      color: #ffffff;
      font-size: 16px;
    }
  }
}
</style>